var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.6667L2.695 12.2192C3.45333 14.3675 3.8325 15.4425 4.6975 16.0542C5.5625 16.6658 6.7025 16.6667 8.98083 16.6667H11.0183C13.2975 16.6667 14.4367 16.6667 15.3017 16.0542C16.1675 15.4425 16.5467 14.3675 17.305 12.2192L17.5 11.6667M10 3.33334V11.6667M10 3.33334C9.41667 3.33334 8.32667 4.99501 7.91667 5.41668M10 3.33334C10.5833 3.33334 11.6733 4.99501 12.0833 5.41668",
    stroke: "#25272C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ccab9ded2dc76e50333f8cbbb995ad2f.svg";
export { ForwardRef as ReactComponent };